export const html = "<p>Try fresh roasted corn in the forests of Dilijan.</p>\n";
export const leadHtml = "<p>Try fresh roasted corn in the forests of Dilijan.</p>\n";
export const bodyHtml = "";
export const metaText = "Try fresh roasted corn in the forests of Dilijan.";